<template>
  <div id="app">
    <div class="footer w-100">
      <div class="footer_txt row">
        <div class="footer1 col-lg-4 col-md-12 col-sm-12">
          <img class="footer-logo" src="../../../static/img/header_logo.png" alt />
          <span class="footer1_txt1">Ningbo Naida Filter Tech Co.,Ltd. es una compañía china comprometidas en proveer soluciones innovadoras para las crecientes necesidades de agua en el mundo,especializada en la fabricación y distribución de equipos para el tratamiento de agua.</span>
          <div class="footer1-1 w-75">
            
          </div>
        </div>
        <div class="footer2 col-lg-4 col-md-12 col-sm-12">
          <span class="footer2_txt">Navegacion Rapida</span>
          <div class="footer2_txt_ul">
            <ul class="footer2_ul">
              <li class="">
                <span><router-link to="/about_ESP"><img src="../../../static/img/li.png" alt="">QUIÉNES</router-link></span>
              </li>
              <li class="">
                <span><router-link to="/download_ESP"><img src="../../../static/img/li.png" alt="">DESCARGAS</router-link></span>
              </li>
              <li class="">
                <span><router-link to="/about_ESP"><img src="../../../static/img/li.png" alt="">NOTICIAS</router-link></span>
              </li>
            </ul>
            <ul class="footer2_ul">
              <li class="">
                <span><router-link :to="{path:'/product_ESP',query:{id:51}}"><img src="../../../static/img/li.png" alt="">PRODUCTOS</router-link></span>
              </li>
              <li class="">
                <span><router-link to="/support_ESP"><img src="../../../static/img/li.png" alt="">SOPORTE</router-link></span>
              </li>
              <li class="">
                <span><router-link to="/contact_ESP"><img src="../../../static/img/li.png" alt="">CONTACTO</router-link></span>
              </li>
            </ul>
          </div>
        </div>
        <div class="footer3 col-lg-4 col-md-12 col-sm-12 w-100">
            <span class="footer3_header w-100">Contacto</span>
            <div class="w-100">
                <img class="img1" src="../../img/地址.png" alt=""><span class="">NO.28,XINGBIN ROAD,SINO-ITALY NINGBO ECOLOGICAL PARK,YUYAO,ZHEJIANG,CHINA</span>
            </div>
            <div class="w-100">
                <img class="img2" src="../../img/手机.png" alt=""><span class="">TEL: (0086) 574 6209 6133</span>
            </div>
            <div class="w-100">
                <img class="img3" src="../../img/邮箱.png" alt=""><span class="">E-mail: <div>sales@waternaida.com</div><div>service@waternaida.com</div></span>
            </div>
            <div><img src="../../img/app.png" alt=""></div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
#app {
  width: 100%;
}
.row {
  padding: 0;
  margin: 0;
}
@media screen and (max-width: 1900px) {
  .footer2_ul {
    width: 50%;
    margin: 0;
    padding: 0;
    margin-top: 20px;
  }
  .footer2 {
    margin-top: 20px;
  }
}
@media screen and (min-width: 1901px) {
  .footer2_ul {
    width: 30%;
    margin: 0;
    padding: 0;
    margin-top: 20px;
  }
  
}
.footer3_header{
    width: 100%;
    font-size: 24px;
    text-align: left;
    /* background-color:hotpink; */
    display: block;
}
.footer3>div>.img1{
    margin-right: 20px;
    margin-top: 6px;
    width: 15px;
    height: 20px;
}
.footer3>div>.img2{
    margin-right: 20px;
    width: 15px;
    height: 20px;
}
.footer3>div>.img3{
    margin-right: 20px;
    width: 15px;
    height: 20px;
}
.footer3>div>span{
    width: 90%;
}
.footer3>div>span div:nth-child(1){
    display: inline-block;
}
.footer3>div>span div:last-child{
    margin-left: 3.4rem;
}
.footer3>div{
    display: flex;
    width: 100%;
    text-align: left;
    /* background-color: green; */
    margin-top: 15px;
}
.footer2_ul > li > span {
  color: gray;
}
.footer2_ul > li > span>a{
  color: gray;
}
.footer2_ul li {
  list-style: none;
  text-align:left;
}
.footer2_ul li img{
  width: 5%;
  margin-right: 5%;
}
.footer2_txt_ul {
  width: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  margin: 0 auto;
}
.footer2_txt {
  font-size: 24px;
  display: block;
  margin: 0 auto;
  margin-left: -44px;
}
.footer1_btn {
  background-color: #009944;
}
.footer1_txt1 {
  display: block;
  margin-top: 30px;
  margin-bottom: 30px;
}
.footer1-1 {
  float: left;
  display: flex;
}
.footer {
  height: 600px;
  margin: 0 auto;
  background: url("../../img/footer_bj.png");
  text-align: center;
  background-size: cover;
}
.footer_txt {
  width: 80%;
  padding-top: 200px;
  margin: 0 auto;
}
.footer1 {
  text-align: left;
}
.footer-logo{
    display: block;
    margin: 0 auto;
    width: 100px;
}
@media screen and (max-width: 992px) {
  .footer{
    height: 450px;
  }
  .footer1{
    text-align: center;
  }
  .footer1>img{
    width: 50% !important;
  }
  .footer1-1{
    margin: 0 auto;
    float:none;
  }
  .footer3 {
    display: none;
  }
  .footer2{
    display: none;
  }
}
@media screen and (max-width: 576px){
  .footer1{
    text-align: center;
    width: 100%;
  }
}
</style>
<script>
export default {
  data() {
    return {
      input: ""
    };
  }
};
</script>


// WEBPACK FOOTER //
// src/components/zzj/footer_ESP.vue